import React, { useState } from 'react';
import { Divider, Stack, Typography } from '@mui/material';
import { theme } from '../../../theme';
import PhysicianEntry from './PhysicianEntry';

function PhysicianGroups(props) {
    const [selectedPhysician, setSelectedPhysician] = useState(null);

    const sortedPhysicians = Object.keys(props.draftGroupings).sort((a, b) => props.draftGroupings[b].savingsOpportunity - props.draftGroupings[a].savingsOpportunity).sort((a, b) => {
        return props.draftGroupings[a].physician.last_name.localeCompare(props.draftGroupings[b].physician.last_name);
    });

    function getInfoText(physicianId) {
        var infoText = props.status === 'active' ?
            `${props.draftGroupings[physicianId].drafts.length} Card${props.draftGroupings[physicianId].drafts.length === 1 ? '' : 's'} Ready for Review` :
            `${props.draftGroupings[physicianId].drafts.length} Card${props.draftGroupings[physicianId].drafts.length === 1 ? '' : 's'} Reviewed`;
        return infoText;
    }

    return (
        <Stack width='100%' divider={<Divider />} sx={{
            border: '1px solid',
            borderRadius: '8px',
            borderColor: theme.palette.border.main,
            backgroundColor: 'white',
        }}>
            <Stack p={2} width='100%'>
                <Typography variant='bold' fontSize='16px'>All Cards</Typography>
                <Typography variant='light' fontSize='12px'>Review all cards assigned to you, sorted by the amount of uncaptured estimated savings per physician.</Typography>
            </Stack>
            { Object.keys(props.draftGroupings).length === 0 &&
                <Typography p={2} variant='normal' sx={{ fontSize: '16px' }}>No cards to review at this time. Check back again later!</Typography>
            }
            { sortedPhysicians.map((physicianId) => {
                return <PhysicianEntry 
                    key={physicianId} 
                    hospital={props.draftGroupings[physicianId].physician.hospital.name}
                    physician={props.draftGroupings[physicianId].physician} 
                    drafts={props.draftGroupings[physicianId].drafts} 
                    status={props.status}
                    selectedPhysician={selectedPhysician}
                    setSelectedPhysician={setSelectedPhysician}
                    infoText={getInfoText(physicianId)}
                    topDrafts={props.topDrafts}
                    variant='clinical'
                />
            })}
        </Stack>
    )
}

export default PhysicianGroups;
